import React from 'react';
import { connect } from 'react-redux';
import { editSensor } from "actions/sensorsettings"

class EditModal extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			macaddress: '',
			name: '',
			loaded: false
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.open != nextProps.open) {
			this.setState({
				macaddress: nextProps.sensor.macaddress,
				name: nextProps.sensor.name,
				loaded: true
			});
		}
	}


	editSensorHandle() {
		var ss = {
			id: this.props.sensor.id,
			macaddress: this.state.macaddress,
			name: this.state.name
		}
		this.props.dispatch(editSensor(ss));
	}

	changeMacAddress(e) {
		this.setState({ macaddress: e.target.value });
		e.preventDefault();
	}

	changeName(e) {
		this.setState({ name: e.target.value });
		e.preventDefault();
	}

	render() {
		let type = "hidden";
		if (this.state.loaded) {
			type = this.props.open ? "open" : "closed";
		}
		return (
			<div>
				<div className={"modals__overlay " + type} onClick={this.props.closeModal}></div>
				<div className={"edit-sensor-wrapper modals__content " + type}>
					<div className="modals__content__header">
						<button className="close" onClick={this.props.closeModal}>×</button>
						<h4 className="modals__content__header__title">Edit Sensor</h4>
					</div>
					<div className="modals__content__body">
						<label>MAC Address</label>
						<input type="text" placeholder="f8:f0:05:f7:fc:cc" value={this.state.macaddress} onChange={this.changeMacAddress.bind(this)} />

						<label>Name</label>
						<input type="text" placeholder="ZA1" value={this.state.name} onChange={this.changeName.bind(this)} />

						<div><span className={this.props.respondClass}>{this.props.respond}</span></div>
					</div>
					<div className="modal-footer">
						<button className="btn btn-default" type="button" onClick={this.props.closeModal}>Cancel</button>
						<button className="btn btn-success" type="button" onClick={this.editSensorHandle.bind(this)}>OK</button>
					</div>
				</div>
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(null, mapDispatchToProps)(EditModal);



// WEBPACK FOOTER //
// ./src/components/pages/sensorsettings/editModal.jsx